__turbopack_context__.v({
  "buyside_form": "styles-module-scss-module__LNRT2q__buyside_form",
  "buyside_widget_autocomplete-items": "styles-module-scss-module__LNRT2q__buyside_widget_autocomplete-items",
  "focus-visible": "styles-module-scss-module__LNRT2q__focus-visible",
  "theme_unifed_search": "styles-module-scss-module__LNRT2q__theme_unifed_search",
});
